import { writable } from "svelte/store"

function newStore() {
  const { subscribe, update, set } = writable({
    closed: true,
    item: null,
  })

  return {
    set,
    subscribe,
    open(item) {
      update((state) => ({ ...state, closed: false, item }))
    },
    close() {
      update((state) => ({ ...state, closed: true, item: null }))
    },
  }
}

export default newStore()
